const mEditionAssetSendingOfDeliverables = {
  mEditionAssetSendingOfDeliverables: {
    alerts: {
      deleteEntregable: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El entregable fue eliminado exitosamente.'
      }
    },

    buttonSecondary: {
      createText: 'Crear Entregable',
      filterText: 'Filtros Avanzados'
    },

    date: {
      delivery: 'Entrega día',
      inmediate: 'Entrega inmediata'
    },

    table: {
      thDate: 'Fecha de Entrega',
      thDelete: 'Eliminar',
      thEdit: 'Editar',
      thSubject: 'Asunto',
      thType: 'Tipo Entregable'
    },

    tooltip: {
      delete: 'Eliminar Entregable',
      disabled: 'Acción Deshabilitada',
      edit: 'Editar Entregable',
      reload: 'Actualizar'
    },

    type: {
      activation: 'Activación',
      message: 'Mensaje'
    },

    unedited: 'Entregable no editado'
  }
}

export default mEditionAssetSendingOfDeliverables
